// 3rd party
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ReportService {

  constructor(
    private http: Http
  ) { }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string, fields?: string): Observable<Response> {
    return this.http
      .get('reports/' + (identifier ? identifier : '') + '?fields=[' + (fields ? fields : '') + ']' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getReportCategory(category: number): string {
    switch (category) {
      case 0: return 'ReportCategory.None';
      case 2: return 'ReportCategory.Instruments';
      case 3: return 'ReportCategory.Standards';
      case 4: return 'ReportCategory.Calibrations';
      case 5: return 'ReportCategory.Customers';
      case 6: return 'ReportCategory.Financial';
      case 7: return 'ReportCategory.ServiceOrders';
      case 8: return 'ReportCategory.Others';
      case 9: return 'ReportCategory.Users';
      case 10: return 'ReportCategory.Suppliers';
      case 11: return 'ReportCategory.Stock';
      case 12: return 'ReportCategory.Contract';
      case 13: return 'ReportCategory.Invoices';
      case 14: return 'ReportCategory.Budgets';
      default: return '';
    }
  }

  load(sql: string, values: any, queryName): Observable<Response> {
    let body = JSON.stringify({ sql: sql, values: values, queryName: queryName });
    let authorization = 'Bearer ' + localStorage.getItem('token');
    let options = new RequestOptions();
    options.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': authorization });
    return this.http
      .post('reports/load', body, options)
      .map((res: Response) => res)
      .catch((err: any) => Observable.throw(err.json().error || 'Server error'));
  }

  view(identifier: string, values?: any): Observable<any> {
    return this.http
      .get('reports/view/' + identifier + (values ? '?values=' + JSON.stringify(values) : ''), { responseType: ResponseContentType.Blob })
      .map(res => new Blob([res.blob()], { type: res.headers.get('content-type').toString() }))
      .catch(err => Observable.throw(new Error(err)));
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/shared/report.service.ts